<div class="index">
  <div class="card" style="width: 18rem">
    <img class="card-img-top" src="{{ img }}" alt="Card image cap" />
    <div class="card-body">
      <p class="card-text font-weight-bold">
        {{ Book.title }}
      </p>
      <p class="card-text font-italic text-right">
        {{ Book.author }}
      </p>
      <p class="card-text">
        {{ Book.description }}
      </p>
    </div>
  </div>
</div>
